/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const TimeIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st0{fill: ${color} !important}`}</style>
			<g id='reloj_3_' transform='translate(257 430.043)'>
				<path
					id='Path_39520'
					className='st0'
					d='M-236.5-426.6c-4.7-4.7-12.3-4.6-17 .1-4.5 4.6-4.6 11.9-.2 16.6.1.1.4.1.5 0 .1-.1.1-.3 0-.5-4.3-4.5-4.1-11.7.5-16 4.5-4.3 11.7-4.1 16 .5s4.1 11.7-.5 16c-4.2 3.9-10.6 4.1-15 .5-.1-.1-.4-.1-.5 0s-.1.4 0 .5c5.1 4.2 12.7 3.5 16.9-1.6 4-4.7 3.6-11.7-.7-16.1z'
				/>
				<path
					id='Path_39521'
					className='st0'
					d='M-238.1-424.9c.1-.1.1-.4 0-.5-4.1-3.8-10.5-3.6-14.2.5-3.8 4.1-3.6 10.5.5 14.2s10.5 3.6 14.2-.5c3.4-3.7 3.6-9.3.5-13.2-.1-.2-.3-.2-.5-.1s-.2.3-.1.5c1.3 1.7 2.1 3.7 2.1 5.9 0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4 4.2-9.4 9.4-9.4c2.4 0 4.7.9 6.4 2.5.1.2.3.2.5.1z'
				/>
				<path
					id='Path_39522'
					className='st0'
					d='M-244.7-425.4v-1.1c0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3v1.1c0 .2.1.4.3.4.3 0 .4-.1.4-.3z'
				/>
				<path
					id='Path_39523'
					className='st0'
					d='M-245.4-410.7v1.1c0 .2.1.4.3.4.2 0 .4-.1.4-.3v-1.1c0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3z'
				/>
				<path
					id='Path_39524'
					className='st0'
					d='M-236.5-417.7c.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4h-1.1c-.2 0-.4.1-.4.3 0 .2.1.4.3.4h1.1z'
				/>
				<path
					id='Path_39525'
					className='st0'
					d='M-253.5-418.4c-.2 0-.4.1-.4.3 0 .2.1.4.3.4h1.1c.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4h-1.1z'
				/>
				<path
					id='Path_39526'
					className='st0'
					d='M-240.3-413.6c.2.1.4.1.5-.1.1-.1.1-.4 0-.5l-3.8-3.2c.1-.2.2-.4.2-.6l2.2-2.3c.4-.4.4-1.1 0-1.5s-1.1-.4-1.5 0l-2.1 2.1h-.5l-4.2-3.7c-.4-.4-1.1-.4-1.5 0s-.4 1.1 0 1.5h.1l2 1.8c.1.1.4.1.5 0 .1-.1.1-.4 0-.5l-2-1.8c-.2-.1-.2-.3-.1-.5s.3-.2.5-.1l4 3.6c-.2.2-.3.3-.4.6l-.9-.8c-.2-.1-.4-.1-.5.1-.1.1-.1.3 0 .5l1.3 1.2c.1.9.9 1.4 1.8 1.3.3 0 .5-.1.7-.3l3.7 3.2zm-1.9-7.6c.1-.1.4-.1.5 0 .1.1.1.4 0 .5l-1.9 1.9c-.1-.2-.3-.4-.5-.5l1.9-1.9zm-2.8 4c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9c-.1.5-.4.9-.9.9z'
				/>
			</g>
		</svg>
	)
}

export default TimeIcon
